import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=bde97dcc&scoped=true&"
import script from "./ExamList.vue?vue&type=script&lang=js&"
export * from "./ExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde97dcc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde97dcc')) {
      api.createRecord('bde97dcc', component.options)
    } else {
      api.reload('bde97dcc', component.options)
    }
    module.hot.accept("./ExamList.vue?vue&type=template&id=bde97dcc&scoped=true&", function () {
      api.rerender('bde97dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/MyExams/components/ExamList.vue"
export default component.exports